import React from 'react'
import { useScriptWithConsent, ScriptLoadResult } from 'common/hooks/useScriptWithConsent'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    link: string // e.g. https://xd.wayin.com/display/container/dc/c9b815c1-f948-4bba-8710-9d457d6a35f5?mode=responsive
}

export const wayinScript = '//xd.wayin.com/ui/ngx.embed.min.js'

export const WayIn: React.FC<Props> = ({ link }) => {
    const [result] = useScriptWithConsent({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
        consentMet: { src: wayinScript },
    })

    if (result === ScriptLoadResult.NotConsented) {
        return <ConsentFallback />
    }

    if (!validateLink(link) || result !== ScriptLoadResult.Success) {
        return null
    }
    const fixedLink = fixWayInLink(link)
    const id = getEmbedIdFromLink(fixedLink)

    return (
        <iframe
            src={fixedLink}
            frameBorder="0"
            scrolling="no"
            width="100%"
            height="auto"
            id={`ngxFrame${id}`}
        />
    )
}

export function isWayIn(link: string) {
    return link.indexOf('xd.wayin.com') >= 0
}

function validateLink(link: string): boolean {
    if (!link || link.indexOf('display/container/dc/') === -1) {
        return false
    }

    return true
}

function fixWayInLink(link: string) {
    if (link.indexOf('?mode=responsive') === -1) {
        return `${link}?mode=responsive`
    }

    return link
}

// e.g. c9b815c1-f948-4bba-8710-9d457d6a35f5
function getEmbedIdFromLink(link: string): string {
    const regex = /.{8}-.{4}-.{4}-.{4}-.{12}/g
    const matchArray = link.match(regex)
    return matchArray ? matchArray[0] : ''
}
